module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_3_2_4.9f371c97.png";